module.exports = __webpack_public_path__ + "img/GG.ea643054.svg";